module.exports = __webpack_public_path__ + "static/media/doctorfinding.423bb081.png";